import './FansLinksSheet.sass';

import { FC, useState } from 'react';
import { useSelector } from 'react-redux';

import { Button, List, ListItem } from '$uikit';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { IcCheck16 } from '$assets';
import { useTranslator } from '$hooks';
import { promoLinksSelector } from '$store/promoLinks';

import { FansLinksFilter } from '../StatisticsProFans.types';

export interface FansLinksSheetProps {
  value: FansLinksFilter;
  onApply: (next: FansLinksFilter) => void;
  onClose: () => void;
}

export const FansLinksSheet: FC<FansLinksSheetProps> = ({ value, onApply, onClose }) => {
  const t = useTranslator();
  const { links } = useSelector(promoLinksSelector);
  const [draft, setDraft] = useState<FansLinksFilter>(value);

  const toggle = (id: number) => {
    setDraft((prev) => {
      if (prev === 'all') return [id];
      return prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id];
    });
  };

  const handleApply = () => {
    onApply(draft);
    onClose();
  };

  const handleReset = () => {
    onApply([]);
    onClose();
  };

  return (
    <BottomSheet
      title={t('statistics_pro_links_title', { defaultValue: 'Referral links' })}
      onClose={onClose}
      className="ActionBottomSheet"
      scroll={false}
    >
      <div className="ActionBottomSheet__content">
        <div className="FansLinksSheet__list">
          <List>
            <ListItem
              indicator={draft === 'all' ? <IcCheck16 /> : null}
              onClick={() => setDraft(draft === 'all' ? [] : 'all')}
            >
              {t('statistics_pro_links_all_links', { defaultValue: 'All links' })}
            </ListItem>
            {links.map((link) => (
              <ListItem
                key={link.id}
                indicator={
                  draft !== 'all' && draft.includes(link.id) ? <IcCheck16 /> : null
                }
                description={link.webUrl}
                descriptionSingleLine
                onClick={() => toggle(link.id)}
              >
                {link.name}
              </ListItem>
            ))}
          </List>
        </div>
        <div className="ActionBottomSheet__footer FansLinksSheet__footer">
          <Button stretched onClick={handleApply}>
            {t('statistics_pro_apply', { defaultValue: 'Apply' })}
          </Button>
          <Button stretched mode="secondary" onClick={handleReset}>
            {t('statistics_pro_reset', { defaultValue: 'Reset' })}
          </Button>
        </div>
      </div>
    </BottomSheet>
  );
};
